/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { ReactComponent as Excel } from '../../assets/themes/OPL/img/icons/FileExcel.svg';

function AcceptButton({ ...props }) {
    const { accepted, classes, callback, callbackParam, tooltipTitle, tooltipPlacement, color, text, ...rest } = props;
    return (
        <TemplateButton
            {...rest}
            className={classes}
            tooltipTitle={tooltipTitle}
            tooltipPlacement={tooltipPlacement}
            classes={classes}
            icon={Excel}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
}

AcceptButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default AcceptButton;
